import { render, staticRenderFns } from "./DispensationRequest.vue?vue&type=template&id=2e71f71a&scoped=true"
import script from "./DispensationRequest.vue?vue&type=script&lang=js"
export * from "./DispensationRequest.vue?vue&type=script&lang=js"
import style0 from "./DispensationRequest.vue?vue&type=style&index=0&id=2e71f71a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e71f71a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e71f71a')) {
      api.createRecord('2e71f71a', component.options)
    } else {
      api.reload('2e71f71a', component.options)
    }
    module.hot.accept("./DispensationRequest.vue?vue&type=template&id=2e71f71a&scoped=true", function () {
      api.rerender('2e71f71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/dipensation-request/DispensationRequest.vue"
export default component.exports